import { cn as e } from "../../lib/utils.es.js";
import * as t from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import * as i from "@radix-ui/react-slider";
// libs/ui-lib/src/components/ui/slider.tsx
function a({ className: a, defaultValue: o, value: s, min: c = 0, max: l = 100, thumbAriaLabel: u, ...d }) {
	let f = t.useMemo(() => Array.isArray(s) ? s : Array.isArray(o) ? o : [c, l], [
		s,
		o,
		c,
		l
	]);
	return /* @__PURE__ */ r(i.Root, {
		"data-slot": "slider",
		defaultValue: o,
		value: s,
		min: c,
		max: l,
		className: e("relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col", a),
		...d,
		children: [/* @__PURE__ */ n(i.Track, {
			"data-slot": "slider-track",
			className: e("bg-muted relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"),
			children: /* @__PURE__ */ n(i.Range, {
				"data-slot": "slider-range",
				className: e("bg-primary absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full")
			})
		}), Array.from({ length: f.length }, (e, t) => /* @__PURE__ */ n(i.Thumb, {
			"data-slot": "slider-thumb",
			"aria-label": u,
			className: "border-primary bg-background ring-ring/50 block size-4 shrink-0 rounded-full border shadow-sm transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50"
		}, t))]
	});
}
export { a as Slider };
